import React, { useEffect, useState } from 'react';
import { SearchAnswer } from './searchAnswers';
import {Button, Col, Divider, Row} from "antd";

export function TableSearchAnswer(props, {surveyId}) {

	const [question, setQuestion] = useState({
		SurveyQuestionId: "",
		SurveyId: parseInt(surveyId),
		SurveyAnswerTypeId: "",
		Question: ""
	});
	const [updateTableAnswers, setUpdateTableAnswers] = useState(false);

	useEffect(() => {
		if (props.currentQuestion) {
			setQuestion({
				SurveyQuestionId: props.currentQuestion.SurveyQuestionId,
				SurveyId: props.currentQuestion.SurveyId,
				SurveyAnswerTypeId: props.currentQuestion.SurveyAnswerTypeId,
				Question: props.currentQuestion.Question
			});
		}
		props.setSelectedAnswer(null);
	}, [props.currentQuestion]);

	const handleOnSelectAnswer = (answer) => {
		props.handleOnCancelEditAnswer(true,null)
		props.setSelectedAnswer({
			SurveyAnswerConfigId: answer.surveyAnswerConfigId,
			SurveyQuestionId: answer.surveyQuestionId,
			AnswerOrder: answer.answerOrder,
			Answer: answer.answer,
			IsRight: answer.isRight,
			IsImage: answer.isImage,
			StepAnswer: answer.stepAnswer
		});
	}

	useEffect(() => {
		setUpdateTableAnswers(!updateTableAnswers)
	}, [props.refreshAnswers])

	return (
		<Row xs={24}>
			<Col xs={24}>
				<Col xs={24}>
					<Divider orientation={"left"}>Listado de respuestas</Divider>
				</Col>
			</Col>
			<Col xs={24}>
				<SearchAnswer
					isSurveyAlreadyStarted={props.isSurveyAlreadyStarted}
					surveyQuestionId={question.SurveyQuestionId}
					onSelectAnswer={handleOnSelectAnswer}
					refresh={updateTableAnswers}
				/>
			</Col>
		</Row>
	);
}
